import React from 'react'
import cx from 'classnames'

import s from './Divider.scss'


export const colors = [ 'gray-30', 'gold-50' ] as const

export type DividerColor = typeof colors[number]

type DividerProps = {
  className?: string
  color?: DividerColor
}

const Divider: React.FunctionComponent<DividerProps> = (props) => {
  const { className, color = 'gray-30' } = props

  const rootClassName = cx(s.divider, `text-${color}`, className)

  return (
    <div className={rootClassName} />
  )
}


export default Divider
